import gql from 'graphql-tag'

const specialistFields = gql`
  fragment specialistFields on Specialist {
    id
    firstName
    lastName
    email
    emailVerified
    companyName
    address1
    address2
    zip
    city
    area
    country
    phone
    stripeAccountId
    canUseStripe
    motherTongue
    vatId: taxId
    vatIdVerification: taxIdVerification
    profileStatus
    languageKnowledges {
      id
      sourceLanguage
      workArea {
        id
        descriptionKey
      }
    }
    termsAccepted
  }
`

export const query = gql`
  ${specialistFields}
  
  query {
    countryCodes

    motherTongues

    sourceLanguages

    workAreas {
      id
      descriptionKey
    }

    specialist {
      ...specialistFields
    }
    
    login {
      id
    }
  }`
export const addOrUpdate = gql`
  ${specialistFields}

  mutation addOrUpdateSpecialist(
    $firstName: String,
    $lastName: String,
    $companyName: String,
    $address1: String,
    $address2: String,
    $zip: String,
    $city: String,
    $area: String,
    $motherTongue: ID,
    $country: String,
    $phone: String,
    $vatId: String,
    $stripeAccountId: String,
    $languageKnowledges: [LanguageKnowledgeData!]
    $terms: Boolean
  ){
    addOrUpdateSpecialist(specialist: {
      firstName: $firstName
      lastName: $lastName
      companyName: $companyName
      address1: $address1
      address2: $address2
      zip: $zip
      city: $city
      area: $area
      motherTongue: $motherTongue
      country: $country
      phone: $phone
      taxId: $vatId
      stripeAccountId: $stripeAccountId
      languageKnowledges: $languageKnowledges
      termsAccepted: $terms
    }) {
      ...specialistFields
    }
  }`



// WEBPACK FOOTER //
// ./Linkgua/components/SpecialistDetails/queries.js